module.exports = __webpack_public_path__ + "media/Audio15_l.ea7b9b28.wav";